import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { TextButton } from '@components/library/button/index';
import RulesRow from './rules_row';
import RuleModal from './rules_modal/main';

import './styles/main.scss';

function RulesManagement(props) {
  const { rules } = props;

  const [showModal, toggleModal] = useState(false);
  const [editableRule, setEditableRule] = useState(null);
  const [queryString, setQueryString] = useState('');
  const [visibleRules, setVisibleRules] = useState(rules);

  useEffect(() => {
    const matchingRules = [];
    const queryMatches = (names) => (
      names.toLowerCase().indexOf(queryString.toLowerCase()) > -1
    );
    for (let i = 0; i < rules.length; i += 1) {
      if (queryMatches(rules[i].actionable_names) || queryMatches(rules[i].scopable_names)) {
        matchingRules.push(rules[i]);
      }
    }
    setVisibleRules(matchingRules);
  }, [rules, queryString]);

  const updateSearch = (event) => {
    setQueryString(event.target.value);
  };

  const resetShowModal = () => {
    toggleModal(false);
    setEditableRule(null);
  };

  return (
    <div className="manage-rules">
      <h2>{bfTranslate('Rules for')} {BF.fx.brandfolder().name}</h2>
      <h5><i>{bfTranslate('NOTE: Rules can only be executed once every 24 hours')}</i></h5>
      <hr />
      <TextButton className="add-rule" icon="bff-plus" onClick={() => toggleModal(true)}>
        {bfTranslate('Add Rule')}
      </TextButton>
      <div className="manage-rules-searchbar">
        <input
          className="bf-input searchbar"
          id="custom-fields-search"
          onChange={updateSearch}
          placeholder={bfTranslate(`Search ${props.rules.length} rules`)}
          type="text"
        />
      </div>
      <div className="headers">
        <h3 className="fifteen">{bfTranslate("Rule")}</h3>
        <h3 className="twenty-five">{bfTranslate("Trigger")}</h3>
        <h3 className="fifteen">{bfTranslate("Action")}</h3>
        <h3 className="ten center">{bfTranslate("Enforce")}</h3>
        <h3 className="ten center">{bfTranslate("Created")}</h3>
        {BFG.currentUser?.su && BFG.currentUser.scope !== 'getty' && (
          <div className="fifteen" />
        )}
        <div className="five" />
        <div className="five" />
      </div>
      { visibleRules.map((rule) => (
        <div key={rule.key} className="rule-row">
          <RulesRow rule={rule} setEditMode={() => setEditableRule(rule)} />
        </div>
      ))
      }
      {(showModal || editableRule) && <RuleModal resetShowModal={resetShowModal} ruleData={editableRule} />}
    </div>
  );
}

RulesManagement.propTypes = {
  rules: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default RulesManagement;
